<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="title-wrapper">
      <div>
        <h1 class="title-default">{{ isEditMode ? 'Editar Serviço Tomado' : 'Cadastro de Serviço Tomado' }}</h1>
        <p class="welcome-message">
          <button mat-icon-button routerLink="/suprimentos/servicos-tomados">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Cadastro manual de NFS-e de entrada · Suprimentos
        </p>
      </div>
    </div>

    @if (isLoading) {
    <div class="d-flex justify-content-center py-5">
      <mat-spinner [diameter]="32"></mat-spinner>
    </div>
    } @else {
    <form [formGroup]="form" (ngSubmit)="salvar()">
      <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

      <app-servico-tomado-dados-cabecalho [form]="form" [listaStatusFiscal]="listaStatusFiscal"></app-servico-tomado-dados-cabecalho>

      <app-servico-tomado-emitente [form]="form"></app-servico-tomado-emitente>

      <app-servico-tomado-servicos [form]="form" [dynamicCurrencyMask]="dynamicCurrencyMask"></app-servico-tomado-servicos>

      <app-servico-tomado-impostos-retidos [form]="form" [dynamicCurrencyMask]="dynamicCurrencyMask"
        [percentageMask]="percentageMask"></app-servico-tomado-impostos-retidos>

      <app-servico-tomado-impostos-creditados [form]="form" [dynamicCurrencyMask]="dynamicCurrencyMask"
        [percentageMask]="percentageMask"></app-servico-tomado-impostos-creditados>

      <app-servico-tomado-totais [form]="form"></app-servico-tomado-totais>

      <app-servico-tomado-pagamento [form]="form" [dynamicCurrencyMask]="dynamicCurrencyMask"></app-servico-tomado-pagamento>

      <app-servico-tomado-dados-adicionais [form]="form" [listaTags]="listaTags"></app-servico-tomado-dados-adicionais>

      <app-footer-action [isLoadingSalvar]="isSaving" (salvar)="salvar()" (cancelar)="cancelar()"></app-footer-action>
    </form>
    }
  </div>
</div>
